<template>
  <div class="detail" ref="searchRef" :style="{'--theme-color': themeColor}">
    <div class="file-show" :style="getFontStyle" v-if="info.info.showSyllable">
      {{ info.info.btnText || '搜索' }}
    </div>
    <div class="style-one" v-if="info.info && info.info.style === 3">
      <i class="iconfont icon-sousuo" @click="dialogVisible = true"></i>
    </div>
    <div
      v-if="info.info && info.info.style === 1 || info.info &&info.info.style === 2"
      style="width: 100%"
    >
      <el-input
        :placeholder="info.info.placeholder || '请输入关键字'"
        v-model="searchText"
        class="ipt-search"
        :style="{ '--el-input-bg-color': 'transparent', '--el-input-border-color': '#dcdfe67a' }"
        ref="elInput"
        @focus="inputFocus"
        @keyup="goSearch"
      >
        <template #append>
          <el-button
            class="ipt-btn"
            :style="{ marginTop: info.info.style === 1 ? '-4px' : '-7px' }"
            @click="goSearch"
          >
            <i class="iconfont icon-sousuo" v-if="info.info.style === 1" />
            <div v-if="info.info.style === 2" class="text">{{ info.info.btnText || '搜索' }}</div>
          </el-button>
        </template>
      </el-input>
    </div>
    <div class="button-four" v-if="info.info.style === 4">
      <el-input
        :placeholder="info.info.placeholder || '请输入关键字'"
        v-model="searchText"
        :style="{ '--el-input-bg-color': 'transparent', '--el-input-border-color': '#dcdfe67a' }"
        @focus="inputFocus"
        ref="elInput"
        @keyup="goSearch"
      ></el-input>
    </div>
    <div class="history-list" ref="historyList" :style="{ '--theme-color': themeColor }" v-show="isAppen && historyList.length !== 0">
      <div class="divisionLine"></div>
      <div class="history-list-item" @click.stop="goSearch({}, item)" v-for="(item, index) in historyList" :key="index">
        <span>{{ item }}</span>
        <i @click.stop="goDel(index)" class="iconfont icon-shanchu3"></i>
      </div>
    </div>
    <el-dialog
      v-model="dialogVisible"
      append-to-body
      :show-close="false"
      class="search-dialog"
      width="30%"
    >
      <el-input v-model="searchText" @keyup="search" :placeholder="info.info.placeholder || '请输入关键字'">
        <template #suffix>
          <i class="iconfont icon-sousuo"></i>
        </template>
      </el-input>
    </el-dialog>
  </div>
</template>

<script>
import search from './search'
export default {
  name: 'searchComp',
  data () {
    return {
      // 搜索的内容
      dialogVisible: false,
    }
  },
  props: {
    fontStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    getFontStyle () {
      // 颜色等于#ccc就是默认值不用修改
      const fontStyle = JSON.parse(JSON.stringify(this.info.fontStyle || this.fontStyle))
      if (fontStyle && fontStyle.color === '#ccc') {
        fontStyle.color = '#333'
      }
      return fontStyle
    },
  },
  methods: {
    goDel(idx) {
      this.historyList.splice(idx, 1)
      localStorage.setItem('history-search', JSON.stringify(this.historyList))
    },
    goSearch(e, name) {
      if (e.keyCode === 13 || e.keyCode === undefined) { 
        const text = name || this.searchText
        if (text) {
          this.historyList.unshift(text)
          const list = new Set(this.historyList)
          this.historyList = [...list]
          localStorage.setItem('history-search', JSON.stringify(this.historyList))
          this.isAppen = false
        }
        if (name || name === 0) this.searchText = name
        this.search(e, name)
      }
    },
    inputFocus() {
      this.initHittory(3)
      this.isAppen = true
    },
  },
  mounted() {
    this.init('search')
  },
  mixins:[search]
}
</script>
<style lang='scss' scoped>
.detail {
  display: flex;
  align-items: center;
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .file-show {
    margin-right: 10px;
    display: flex;
    font-size: 14px;
    justify-content: center;
    white-space: nowrap;
    color: #666666;
  }
  ::v-deep .el-input__inner {
    font-size: 12px;
    &:focus {
      border-color: $themeColor !important;
    }
  }
  .style-one {
    color: $themeColor;
    .icon-sousuo {
      cursor: pointer;
      font-size: 22px;
    }
  }
  ::v-deep .button-four {
    flex: 1;
    .el-input {
      height: 30px;
      line-height: 30px;
      .el-input__inner {
        height: 30px;
        line-height: 30px;
      }
    }
  }
  ::v-deep .el-input {
    height: 30px !important;
    .el-input__inner {
      height: 30px !important;
      line-height: 30px !important;
      padding-left: 15px;
    }
  }
  ::v-deep .ipt-search {
    flex: 1;
    .ipt-btn {
      width: 48px;
      height: 33px;
      line-height: 30px;
      padding: 0 10px;
      background: $themeColor;
      font-size: 20px;
      color: #fff;
      border: 1px solid $themeColor;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      .icon-sousuo {
        font-size: 24px;
      }
      .text {
        height: 100%;
        width: 100%;
        font-size: 12px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
  .el-input {
    .el-input__inner {
      border-radius: 0;
    }
    .el-input__suffix {
      line-height: 30px;
      cursor: pointer;
      .icon-sousuo {
        font-size: 24px;
      }
    }
  }
}
::v-deep .el-dialog__header {
  padding: 0px;
}

.history-list {
  $themeColor: var(--theme-color);
  position: absolute;
  min-height: 100px;
  width: 100%;
  border-top: none;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  border: solid 1px $themeColor;
  border-top: none;
  .divisionLine {
    width: 100%;
    height: 1px;
    background-color: #D1D4DC;
    margin: 12px 0;
  }
  .history-list-item {
    width: 100%;
    box-sizing: border-box;
    height: 34px;
    color: #333333;
    font-weight: 400;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    cursor: pointer;
    .icon-shanchu3 {
      font-size: 14px;
      color: #333333;
      display: none;
    }
    span {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:hover {
      color: $themeColor;
      .icon-shanchu3 {
        color: $themeColor;
        display: block;
      }
    }
  }
}
</style>
